module.exports = __webpack_public_path__ + "static/media/Kajima2D.7e30cc95.png";